<template>
    <el-dialog class="cert"
               center
               width="480px"
               :visible.sync="visible"
               title="证书信息"
               :before-close="doClose">
        <div class="cert-info">
            <img class="cert-img"
                 src="../../../assets/images/common/cert.png"
                 alt="">
            <el-row>
                <el-col :span="6"
                        class="text-right">颁发者：</el-col>
                <el-col :span="18"
                        class="text-left">
                    {{cert.IssuerDN}}
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"
                        class="text-right">颁发给：</el-col>
                <el-col class="text-left"
                        :span="18">{{cert.SubjectDN}}</el-col>
            </el-row>
            <el-row>
                <el-col :span="6"
                        class="text-right">有效期：</el-col>
                <el-col class="text-left"
                        :span="18">
                    {{cert.NotBefore}} ~ {{cert.NotAfter}}
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6"
                        class="text-right">DN：</el-col>
                <el-col class="text-left"
                        :span="18">{{cert.SubjectDN}}</el-col>
            </el-row>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data () {
        return {
            cert: {}
        };
    },
    props: {
        visible: Boolean,
        certKey: String
    },
    mounted () {
        this.getCertInfo();
    },
    methods: {
        /**
         * 获取证书信息
         */
        async getCertInfo () {
            try {
                let resp = await this.axios({
                    url: '/seal/record/cert/info',
                    method: 'GET',
                    params: { key: this.certKey }
                });
                resp = resp.data;
                if (resp.code === 0) {
                    this.cert = resp;
                } else {
                    this.$message.error(resp.message);
                }
            } catch (error) {
                console.log(error);
            }
        },

        /**
         * 关闭印章
         */
        doClose () {
            this.$emit('update:visible', false);
            this.$emit('update:certKey', '');
        },

    }
};
</script>

<style lang="less" scoped>
.cert-info {
    line-height: 40px;

    .cert-img {
        width: 60%;
        margin: 0 auto;
    }
}
</style>
<style lang="less">
.cert {
    .el-dialog__body {
        padding-top: 5px;
    }
}
</style>
